import { render, staticRenderFns } from "./businessFile.vue?vue&type=template&id=2fbc2f7f&scoped=true"
import script from "./businessFile.vue?vue&type=script&lang=js"
export * from "./businessFile.vue?vue&type=script&lang=js"
import style0 from "./businessFile.vue?vue&type=style&index=0&id=2fbc2f7f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbc2f7f",
  null
  
)

export default component.exports